import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import RentalOrderDetailScreen from './screens/RentalOrderDetailScreen';
import RentalOrderListScreen from './screens/RentalOrderListScreen';

function RentalOrders() {
  return (
    <KT01BaseLayout isFullScreen>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<RentalOrderListScreen />} />
          <Route path=":rentalOrderId" element={<RentalOrderDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default RentalOrders;
